import React from 'react';
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { FormGroup, Table, Link } from 'arag-ui-lib';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { 
    ESTIMATED_MEDICAL_EXPERT_FEES_MN,
    PRIMARY,
    TERTIARY,
    LEFT,
    ID,
    ROW_INDEX,
    APPLICATION_MEDICAL_EXPERT_FEES,
} from "../../../helpers/constants";
import { 
    ANSWER_UPDATE_ACTION, 
    DEFAULT_MEDICAL_EXPERT_FEE, 
    INFO_TEXT_EDIT_WITH_APPROVAL, 
    INFO_TEXT_EDIT_WITHOUT_APPROVAL 
} from '../../../helpers/variables';
import { medicalExpertFeesActionColumn, medicalFeesTableColumns } from '../../../helpers/utilFunctions';
import QuestionEditActions from '../QuestionEditActions';

const TableInputType = (props) => {
    const {
        question,
        formData,
        isPlain,
        application,
        medicalExpertFees,
        breachCausationCp,
        handleMedicalFeesTableRows,
        handleEditRowClick,
        medicalFeesTableHandler,
        isAnswerEditModalOpen,
        openEditQuestionAnswerModal,
        openDeleteAnswerModal,
        openHistoryModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        checkIfQuestionsHasBeenModified,
        getApprovalSettings,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        isApplicationTab,
    } = props;
    const isModified = (id) => checkIfQuestionsHasBeenModified(id, application, ESTIMATED_MEDICAL_EXPERT_FEES_MN);
    const approvalSettings = getApprovalSettings(question);
    const iconVariant = approvalSettings && approvalSettings.changesRequiresARAGApproval ? PRIMARY : TERTIARY;
    const informationText = approvalSettings && approvalSettings.changesRequiresARAGApproval ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL;
    const key = isAnswerEditModalOpen ? ID : ROW_INDEX;
    const isMedExpertFeesTableEditable = checkIfPlainEditable(question, APPLICATION_MEDICAL_EXPERT_FEES);
    const pendingChanges = checkIfQuestionHasPendingChanges(question.id, application, ESTIMATED_MEDICAL_EXPERT_FEES_MN);
    const tableTestId = isAnswerEditModalOpen ? 'edit-modal-medical-expert-fees' : 'policy-application-medical-expert-fees';
    
    const actionsColumn = (isPlain && isApplicationTab)
    ? 
        medicalExpertFeesActionColumn(
            iconVariant,
            isMedExpertFeesTableEditable,
            handleEditRowClick,
            openDeleteAnswerModal,
            openHistoryModal,
            question,
            approvalSettings,
            informationText,
            isModified,
            medicalExpertFees
        )
    :
        [];
    
    const columns = [
        ...medicalFeesTableColumns(
            !isPlain,
            breachCausationCp,
            medicalFeesTableHandler,
            key
        ),
        ...actionsColumn
    ];

    const AccordionHeader = (row) => (`${row.name} - ${row.natureOfExpert}`);
    const data = medicalExpertFees.map((fee, index) => {
        const breachCausationCpId = fee.breachCausationCpId || '';
        return {
            ...fee,
            breachCausationCpId: breachCausationCpId,
            rowIndex: index
        };
    });

    return (
        <>
            <FormGroup
                variant={FORM_GROUP_VARIANTS.PLAIN}
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={question.name}
                inputProps={{
                    id: `question-id-${question.id}`,
                    name: question.machineName,
                    required: question.isRequired,
                }}
                hasInlineElements={pendingChanges}
                inlineGroupElements={
                    pendingChanges 
                    ?
                        <div className={"col-sm-3"}>
                            <QuestionEditActions
                                checkIfPlainEditable={false}
                                question={question}
                                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                approvalOptions={approvalOptions}
                                onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                                hasPendingChanges={pendingChanges}
                            />
                        </div>
                    : 
                        null
                }
                formGroupTestId={`policy-application-${question.machineName}`}
            />
            
            <div className='row'>
                <div className='col-sm-12'>
                    <div className={'table-container'}>
                        <Table 
                            columns={columns}
                            data={data}
                            accordionItemHeaderFormatter={AccordionHeader}
                            tableWrapperTestId={tableTestId}
                        />
                    </div>
                </div>
            </div>
            {
                !isAnswerEditModalOpen
                ?
                    <Link
                        key={question.name}
                        label={CONTENT_STRINGS.ADD_ANOTHER}
                        variant={TERTIARY}
                        onClick={(
                            isPlain
                            ?
                                () => openEditQuestionAnswerModal({
                                    applicationUpdateAction: ANSWER_UPDATE_ACTION.ADD,
                                    questionAnswerForEdit: question,
                                    questionAnswer: formData[question.id],
                                    questionAnswerMedicalExpertFees: [DEFAULT_MEDICAL_EXPERT_FEE]
                                })
                            :
                                handleMedicalFeesTableRows
                        )}
                        arrowDirection={LEFT}
                        linkTestId={'policy-application-MedicalExpertAdd'}
                    />
                : 
                    null
            }
        </>
    );
};

export default TableInputType;